export default "__VITE_ASSET__Bh6hP6cP__"